export const richTextBoxMetadata = {
  allowConnectToDB: true,
  overrideProportionalResize: false,
};
